@let _pinCardContentClasses = "p-0!";
@let _pinnedSubmission = pinnedSubmission();
@if (_pinnedSubmission) {
  @let _notificationType = _pinnedSubmission.todo > 0 ? "to-do" : "on_hold";
  <wcg-pin-card
    [pinCardType]="_notificationType"
    [pinCardContentClasses]="_pinCardContentClasses"
  >
    <div class="w-full flex flex-row justify-between gap-4" pincard-title>
      <h4
        class="title-small block flex-1 min-w-0 truncate! pinned-card__title--link"
        [matTooltip]="_pinnedSubmission.name"
        matTooltipClass="w-full"
        role="button"
        tabindex="0"
        (click)="navigateToDetail(_pinnedSubmission)"
      >
        {{ _pinnedSubmission.name | wcgTruncate: 0 : 25 }}
      </h4>
      <wcg-chip
        [elevated]="false"
        [label]="
          notificationLabelMapper.get(_notificationType) ?? _notificationType
            | titlecase
        "
        [contrast]="false"
        [type]="
          notificationChipMapper.get(_notificationType) ?? chipType.NEUTRAL
        "
        [size]="chipSize.SLIM"
        [outlined]="false"
      />
    </div>

    <div
      class="w-full flex flex-col gap-2 pinned-card__content--clickable"
      pincard-content
      role="button"
      tabindex="0"
      (click)="navigateToDetail(_pinnedSubmission)"
      (keydown.enter)="navigateToDetail(_pinnedSubmission)"
    >
      @if (_pinnedSubmission.priority) {
        <div class="w-full flex flex-row gap-2">
          <mat-icon
            [svgIcon]="submissionIconMapper.get('priority')!"
            class="pinned-card_Container-content-icons"
          />
          <span class="body-small">
            <span class="font-medium">Priority:</span>
            {{ _pinnedSubmission.priority }}
          </span>
        </div>
      }

      @if (_pinnedSubmission.study.sponsor_protocol_id) {
        <div class="w-full flex flex-row gap-2">
          <mat-icon
            [svgIcon]="submissionIconMapper.get('sponsor_protocol_id')!"
            class="pinned-card_Container-content-icons"
          />
          <span class="body-small">
            <span class="font-medium">Sponsor ID:</span>
            {{ _pinnedSubmission.study.sponsor_protocol_id }}
          </span>
        </div>
      }

      @if (_pinnedSubmission.sponsor) {
        <div class="w-full flex flex-row gap-2">
          <mat-icon
            [svgIcon]="submissionIconMapper.get('sponsor')!"
            class="pinned-card_Container-content-icons"
          />
          <span class="body-small">
            <span class="font-medium">Sponsor name:</span>
            {{ _pinnedSubmission.sponsor }}
          </span>
        </div>
      }

      <div class="w-full flex flex-row gap-2">
        <mat-icon
          [svgIcon]="submissionIconMapper.get('sites')!"
          class="pinned-card_Container-content-icons"
        />
        @if (_pinnedSubmission.is_multisite) {
          <span class="body-small">Multi Sites ({{ $siteCount() }})</span>
        } @else {
          <span class="body-small">
            <span class="font-medium">PI:</span>
            {{ _pinnedSubmission.pi }}
          </span>
        }
      </div>
    </div>
  </wcg-pin-card>
}

@if (loadSkeletonLoader()) {
  @let _loadingStateClasses =
    `${_pinCardContentClasses} ${loadingStateClasses()}`;
  @if (!loadingStateViaCarousel()) {
    @for (_ of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track $index) {
      <ng-container
        [ngTemplateOutlet]="submissionLoadingStateRef"
        [ngTemplateOutletContext]="{
          loadingStateClasses: _loadingStateClasses,
        }"
      />
    }
  } @else {
    <ng-container
      [ngTemplateOutlet]="submissionLoadingStateRef"
      [ngTemplateOutletContext]="{
        loadingStateClasses: _loadingStateClasses,
      }"
    />
  }
}

<ng-template #submissionLoadingStateRef let-stateClasses="loadingStateClasses">
  <wcg-pin-card [pinCardContentClasses]="stateClasses">
    <div class="w-full flex flex-row justify-between gap-4" pincard-title>
      <div class="flex-1 min-w-0">
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            height: '14px',
            width: '60%',
            margin: '0',
            borderRadius: '4px',
          }"
        />
      </div>
      <div class="flex flex-row items-center gap-4">
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            height: '20px',
            width: '52px',
            margin: '0',
            borderRadius: '10px',
          }"
        />
        <ngx-skeleton-loader
          animation="pulse"
          [theme]="{
            height: '18px',
            width: '18px',
            margin: '0',
            borderRadius: '3px',
          }"
        />
      </div>
    </div>

    <div class="w-full flex flex-col gap-2" pincard-content>
      @for (_ of [1, 2, 3, 4]; track $index) {
        <div class="w-full flex flex-row gap-2 items-center">
          <ngx-skeleton-loader
            animation="pulse"
            [theme]="{
              height: '14px',
              width: '14px',
              margin: '0',
              borderRadius: '2px',
            }"
          />
          <div class="flex-1">
            <ngx-skeleton-loader
              animation="pulse"
              [theme]="{
                height: '12px',
                width: skeletonWidths[$index],
                margin: '0',
                borderRadius: '3px',
              }"
            />
          </div>
        </div>
      }
    </div>
  </wcg-pin-card>
</ng-template>
